import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import createBrowserHistory from 'history/createBrowserHistory';

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();

export const stores = {
  // Key can be whatever you want
  routing: routingStore,
  // ...other stores
};

export const history = syncHistoryWithStore(browserHistory, routingStore);


// WEBPACK FOOTER //
// ./src/services/mobx-router/index.ts